import { render, staticRenderFns } from "./card-attach-files.vue?vue&type=template&id=411541be&"
import script from "./card-attach-files.vue?vue&type=script&lang=js&"
export * from "./card-attach-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports